var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDentalIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "tooth-solid 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.6313 2.84932C10.5813 2.13838 9.29375 1.7501 7.96875 1.7501C4.66875 1.7501 2 4.08525 2 6.97275V7.31182C2 8.17588 2.23125 9.02354 2.66875 9.8001L4.1375 12.3759C4.41875 12.8626 4.6125 13.3821 4.725 13.9181L7.01875 25.1728C7.14375 25.7853 7.74375 26.2337 8.45 26.2556C9.15625 26.2774 9.7875 25.8509 9.95 25.2493L11.7563 18.6157C12.0125 17.7024 12.9375 17.0626 14 17.0626C15.0625 17.0626 15.9875 17.7024 16.2375 18.6103L18.0438 25.2439C18.2063 25.8509 18.8375 26.272 19.5438 26.2501C20.25 26.2282 20.85 25.7798 20.975 25.1673L23.2687 13.9126C23.3812 13.3767 23.575 12.8571 23.8563 12.3704L25.325 9.79463C25.7688 9.02354 25.9937 8.17041 25.9937 7.30635V7.1915C25.9937 4.18369 23.2062 1.74463 19.7687 1.74463C18.2625 1.74463 16.8062 2.22588 15.6687 3.08994L15.4688 3.24307L16.6875 4.07432C17.125 4.36963 17.2 4.92197 16.8625 5.30479C16.525 5.6876 15.8938 5.75322 15.4563 5.45791L13.9312 4.41885L11.6187 2.84385L11.6313 2.84932Z",
    fill: "#6210CC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDentalIcon);
export default __webpack_public_path__ + "static/media/dental_icon.670da5952e40f5cc84ef4f57b1320a08.svg";
export { ForwardRef as ReactComponent };